enum PermissionTypesEnum {
    Admin = 'Admin',
    SuperAdmin = 'SuperAdmin',
}

export default PermissionTypesEnum;
